import { CheckoutState } from '../../state';
import { getNamespaceValue } from '../utils/selector';
export const getChildEventId = (state: CheckoutState) =>
    getNamespaceValue(state.event, 'childEventId');
